import { ReaderByUserSearchForm } from './ReaderByUserSearchForm'
import { withReaderByUserSearchForm } from './withReaderByUserSearchForm'

const ConnectedReaderByUserSearchForm = withReaderByUserSearchForm(
  ReaderByUserSearchForm
)

export { ConnectedReaderByUserSearchForm as ReaderByUserSearchForm }
